<template>
  <b-modal ref="modalRef" centered :title="groupSize ? 'Disable awards' : 'Disable award'" @hidden="onHidden">
    <p v-if="groupSize">
      Are you sure you want to disable all {{ groupSize }} awards in <strong>{{ programName }}</strong
      >?
    </p>
    <p v-else>
      Are you sure you want to disable <strong>{{ programName }}</strong
      >?
    </p>
    <p class="text-muted mb-0">
      When disabled, {{ groupSize ? 'these awards' : 'this award' }} will not be visible to employees and no new
      nominations can be made.
    </p>

    <template #modal-footer>
      <b-button variant="outline-secondary" @click="modalRef?.hide()">Cancel</b-button>
      <b-button variant="danger" @click="onConfirm">{{ groupSize ? 'Disable awards' : 'Disable award' }}</b-button>
    </template>
  </b-modal>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  programName: {
    type: String,
    default: '',
  },
  // Set when disabling a whole award group; programName is then the group's name.
  groupSize: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['confirmed']);

const modalRef = ref(null);

const show = () => {
  modalRef.value?.show();
};

const onConfirm = () => {
  emit('confirmed');
  modalRef.value?.hide();
};

const onHidden = () => {
  // No cleanup needed
};

defineExpose({ show });
</script>
